up.popup = {
    attach(origin, options = {}) {
        origin = up.fragment.get(origin);
        up.migrate.deprecated('up.popup.attach(origin)', "up.layer.open({ origin, layer: 'popup' })");
        return up.layer.open(Object.assign(Object.assign({}, options), { origin, layer: 'popup' }));
    },
    close(options = {}) {
        up.migrate.deprecated('up.popup.close()', 'up.layer.dismiss()');
        up.layer.dismiss(null, options);
        return up.migrate.formerlyAsync('up.layer.dismiss()');
    },
    url() {
        up.migrate.deprecated('up.popup.url()', 'up.layer.location');
        return up.layer.location;
    },
    coveredUrl() {
        var _a;
        up.migrate.deprecated('up.popup.coveredUrl()', 'up.layer.parent.location');
        return (_a = up.layer.parent) === null || _a === void 0 ? void 0 : _a.location;
    },
    get config() {
        up.migrate.deprecated('up.popup.config', 'up.layer.config.popup');
        return up.layer.config.popup;
    },
    contains(element) {
        up.migrate.deprecated('up.popup.contains()', 'up.layer.contains()');
        return up.layer.contains(element);
    },
    isOpen() {
        up.migrate.deprecated('up.popup.isOpen()', 'up.layer.isOverlay()');
        return up.layer.isOverlay();
    },
    sync() {
        up.migrate.deprecated('up.popup.sync()', 'up.layer.sync()');
        return up.layer.sync();
    }
};
up.migrate.renamedEvent('up:popup:open', 'up:layer:open');
up.migrate.renamedEvent('up:popup:opened', 'up:layer:opened');
up.migrate.renamedEvent('up:popup:close', 'up:layer:dismiss');
up.migrate.renamedEvent('up:popup:closed', 'up:layer:dismissed');
up.migrate.targetMacro('up-popup', { 'up-layer': 'new popup' }, () => up.migrate.deprecated('[up-popup]', '[up-layer="new popup"]'));
